import React from "react";
import { useTranslation } from "react-i18next";

export const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  confirmText,
  cancelText,
  variant = "danger",
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleConfirm = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onConfirm();
    onClose();
  };

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClose();
  };

  return (
    <div className="gpc-confirm-toast-container gpc-animate-slide-down">
      <div className={`gpc-confirm-toast ${variant === "danger" ? "gpc-confirm-toast-danger" : ""}`}>
        <p className="gpc-confirm-toast-message">{message}</p>
        <div className="gpc-confirm-toast-actions">
          <button
            type="button"
            onClick={handleClose}
            className="gpc-confirm-toast-button gpc-confirm-toast-button-cancel gpc-focus-visible gpc-transition"
          >
            {cancelText || t("conversations.cancel", "Cancel")}
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="gpc-confirm-toast-button gpc-confirm-toast-button-confirm gpc-focus-visible gpc-transition"
          >
            {confirmText || t("conversations.delete", "Delete")}
          </button>
        </div>
      </div>
    </div>
  );
};
